import React from 'react'
import { observer } from 'mobx-react'
import FilterControlsToggleButton from 'components/FilterControlsToggleButton'
import { useToggle } from 'hooks/state-hooks'
import FilterControls from 'infra/FilterControls'
import {
  TableSearchbar,
  TableSearchbarMenuItem,
} from 'payouts/components/TableSearchbar'
import { UserManagementViewModel } from 'user-management/views/UserManagement/UserManagementViewModel'
import UserManagementTableMenu from '../UserManagementTableMenu'

interface TableControlsProps {
  vm: UserManagementViewModel
}

function UserManagementTableControls({ vm }: TableControlsProps) {
  const userSearchVM = vm.userSearch
  const hasFilters = userSearchVM.filters.appliedFilterCount > 0
  const showingFilterControls = useToggle(hasFilters)

  return (
    <>
      <TableSearchbar
        disabled={false}
        searchText={userSearchVM.searchText.value}
        onSearchTextChange={userSearchVM.searchText.change}
      >
        <TableSearchbarMenuItem>
          <FilterControlsToggleButton
            active={showingFilterControls.isEnabled}
            count={userSearchVM.filters.appliedFilterCount}
            onClick={showingFilterControls.toggle}
          />
        </TableSearchbarMenuItem>

        <TableSearchbarMenuItem>
          <UserManagementTableMenu vm={vm} />
        </TableSearchbarMenuItem>
      </TableSearchbar>

      <FilterControls
        active={showingFilterControls.isEnabled}
        vm={userSearchVM.filters}
      />
    </>
  )
}

export default observer(UserManagementTableControls)
